import { ComponentTypes } from "@/Apps/Pages/Editor/types";
import { cleanThisContent } from "@/Apps/Pages/V2Editor/actions";
import { EditorObjectState } from "@/Apps/Pages/V2Editor/components/EditorObject/types";
import { MessageItem, NiceBadge } from "@/ui/CommunicationView/ChatConversation/PromptMessageContainer/PromptMessageContainer";
import { Pencil } from "@phosphor-icons/react";
import { useEffect, useMemo, useRef } from "react";
import { addBodyIfNone } from "../../PageBuilderArtifact";
import _ from "lodash";

export const PageCopywritingFromStructuredMessage = (props: any) => {
  const { payload = {}, name, allMessages = [], artifactOptions = {}, setArtifactOptions = () => {} } = props;

  const { associations = [], count = 0, prompt, id } = payload;
  
  // Track if we've already processed these associations to prevent infinite loops
  const processedAssociationsRef = useRef<string>("");
  
  // Use refs to get latest values without causing dependency issues
  const artifactOptionsRef = useRef(artifactOptions);
  const setArtifactOptionsRef = useRef(setArtifactOptions);
  
  // Update refs with latest values
  artifactOptionsRef.current = artifactOptions;
  setArtifactOptionsRef.current = setArtifactOptions;

  // Memoize the associations string to detect real changes
  const associationsKey = useMemo(() => {
    const key = JSON.stringify(associations);
    // console.log("🔍 PageCopywriting associationsKey memoized:", key);
    return key;
  }, [associations]);

  // Add a debounced effect to only process when associations are stable
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      // console.log("🔍 PageCopywriting debounced effect triggered:", {
      //   associationsLength: associations?.length,
      //   associationsKey,
      //   processedAssociationsRef: processedAssociationsRef.current,
      //   shouldProcess: (Boolean(associations?.length) && associations?.length > 0) && associationsKey !== processedAssociationsRef.current
      // });

      if ((Boolean(associations?.length) && associations?.length > 0) && associationsKey !== processedAssociationsRef.current) {
        // Mark these associations as processed
        processedAssociationsRef.current = associationsKey;

        console.log("🔍 PageCopywriting PROCESSING associations:", associations);

        // get the current page content using ref to avoid dependency issues
        const currentOptions = artifactOptionsRef.current;
        const { pageContent = [] } = currentOptions?.container || {};

        console.log("🔍 PageCopywriting pageContent", pageContent);

        // update the page content with the new copy
        const updatedContent = pageContent.map((item: any) => {
          const association = associations.find((association: any) => association.elementId === item.id);
          if (association) {
            return {
              ...item,
              [item.type === ComponentTypes.BUTTON ? "caption1" : "html"]: association.copy,
              state: EditorObjectState.NORMAL,
              leaveState: EditorObjectState.NORMAL,
            };
          }
          return item;
        });

        console.log("🔍 PageCopywriting updatedContent", updatedContent);

        const newArtifactOptions = {
          ...currentOptions,
          isShowing: true,
          container: {
            ...currentOptions.container,
            type: "page_builder",
            title: "Page Builder (Copywriting)",
            pageContent: addBodyIfNone(cleanThisContent(updatedContent)),
          },
        };

        console.log("pageCopywriting", "newArtifactOptions", newArtifactOptions);
        setArtifactOptionsRef.current?.(newArtifactOptions);

        // now scroll to the section (but only if it's the first or the last section)
         const sectionItem = pageContent?.find((item: any) => item.id === id);
         if (sectionItem) {
           const sections = pageContent?.filter((item: any) => item.type === ComponentTypes.SECTION);
           const sectionIndex = sections?.indexOf(sectionItem);
           if (sectionIndex === 0 || sectionIndex === sections?.length - 1) {
             document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
           }
         }
       }
     }, 500); // Wait 500ms for associations to stabilize

     return () => clearTimeout(timeoutId);
   }, [associationsKey, associations]); // Depend on both associationsKey and associations

  if (!id) return null; // <span>•</span>

  const item = artifactOptions?.container?.pageContent?.find((item: any) => item.id === id)
  // doesn't find the item after run ends because the section content gets refactored 
  // after the run ends, which changes the ids
  const itemLabel = item?.label || item?.name || item?.type;
  const itemType = item?.type;
  const caption = item ? `${count > 0 ? "Improving the" : "Writing"} copy for your ${_.startCase(_.toLower(itemLabel))} ${itemType === itemLabel ? "" : itemType}` : `${count > 0 ? "Improving" : "Writing"} the copy`;

  return (
    <div onClick={() => console.log("payload", payload, artifactOptions, item)}>
      {/* {JSON.stringify(payload)} */}
      <NiceBadge
        caption={caption}
        onClick={() => {
          document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
          // if (associations.length > 0) {
          //   const firstElement = associations?.[0]?.elementId;
          //   if (firstElement) {
          //     document.getElementById(firstElement)?.scrollIntoView({ behavior: "smooth" });
          //   }
          // }
        }}
        icon={<Pencil />}
      />
      {/* <p className="chat-message-text text-[1.0rem] py-3 text-gray-500">
        {prompt}
      </p> */}
      <MessageItem message={prompt} />
      {/* <ReactJson src={payload} name={payload?.artifactId} collapsed /> */}
    </div>
  );
};
